/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  Button
} from '../'

export class ActionsToolbar extends React.Component {
  static propTypes = {
    primaryAction: PropTypes.shape({
      element: PropTypes.object,
      label: PropTypes.string,
      onClick: PropTypes.func
    }),
    secondaryActions: PropTypes.arrayOf(
      PropTypes.shape({
        element: PropTypes.object,
        label: PropTypes.string,
        onClick: PropTypes.func
      })
    ),
    className: PropTypes.string
  }

  render() {
    let primaryAction = this.props.primaryAction
    let secondaryActions = this.props.secondaryActions

    return (
      <div className={`slds-size_1-of-1${this.props.className ? ` ${this.props.className}` : ''}`}>
        {primaryAction
          ? <Button
              type="brand"
              onClick={primaryAction.onClick}
              className="slds-m-right_large">
              {primaryAction.label}
            </Button>
          : <span></span>
        }
        {secondaryActions && secondaryActions.length > 0
          ? secondaryActions.map((action) => (
              <Button
                onClick={action.onClick}
                className="slds-m-right_x-small"
                key={action.label}>
                {action.label}
              </Button>
            ))
          : <span></span>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/actions-toolbar/index.js